import React from 'react'

export default class Toggler extends React.Component {
    constructor(props) {
        super(props)
        this.valueNames = Object.keys(this.props.values)

        this.state = {
            current: this.props.default || this.valueNames[0],
        }
    }

    componentWillReceiveProps (nextProps) {
        if ( (nextProps.selectedTab !== this.props.selectedTab) || (nextProps.followTab !== this.props.followTab)) {
            this.props = nextProps;
            this.valueNames = Object.keys(this.props.values)

            this.setState({
                current: this.props.default || this.valueNames[0],
            });
        }
    }

    selectionChanged = () => {
        if (this.props.disabled===true) {
            return
        }
        let k = 0
        for (let i=0; i<this.valueNames.length; i++) {
            if (this.valueNames[i]===this.state.current) {
                k = (i+1)%this.valueNames.length
                break
            }
        }
        this.setState({current: this.valueNames[k]})

        if (this.props.onChange) {
            this.props.onChange(this.valueNames[k])
        }
    }

    render() {
        return (
            <span
                title={this.props.title}
                className={this.props.className}
                onClick={this.selectionChanged}
                style={{cursor: (this.props.disabled?'default':'')}}
            >{this.props.pre}<span className="btn">{this.props.values[this.state.current]}</span></span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Toggler.js